import { Grid } from "@mui/material";
import background from "assets/loyalty-points/background-added-v2.jpg";
import classNames from "classnames";
import CTA from "components/Buttons/ThemeButton";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch } from "hooks";
import useBreakpoints from "hooks/useBreakpoints";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onClosePopUp, onScrollToShopSection } from "redux/slices";
import { Background, Body, Container, Head, Note } from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { IPlaygamiAnalyticProps } from "interfaces/analytics/playgami";

interface LoyaltyPointsAddedProps {}

export const LoyaltyPointsAdded: React.FC<LoyaltyPointsAddedProps> = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { isSmDown } = useBreakpoints();
	const { syncUserTracker } = useWebStoreContext();
	const scale = useCalculateScale(370 + 40, 370 + 40);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const reportAnalytics = ({ event_name }: IPlaygamiAnalyticProps) => {
		const event_type = "loyalty_points_added_dialog";
		reportPlaygamiEvent("tp.web_frontend", {
			event_name,
			event_type,
			action: event_name,
			source: event_type
		});
	};

	const onClick = () => {
		reportAnalytics({
			event_name: "continue_shopping_click"
		});
		onClose();
		navigate("/shop");
		dispatch(onScrollToShopSection("Featured Deals"));
	};

	const onClose = () => {
		reportAnalytics({
			event_name: "dialog_x_closed"
		});
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		syncUserTracker();
	}, []);

	useEffect(() => {
		reportAnalytics({ event_name: "dialog_shown" });
	}, []);

	return (
		<Container
			className={classNames([isSmDown && "mobile", !isSmDown && "landscape"])}
			scale={scale}
		>
			<CloseIconButton onClose={onClose} />
			<Head>
				<Background src={background} />
			</Head>
			<Body>
				<Note className="note">
					Your Loyalty Points have been added to your balance!
				</Note>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						/* sm={isMobile ? 6 : 12} */ display="flex"
						justifyContent="center"
					>
						<CTA
							themeColor="secondary"
							sx={{
								minWidth: { xs: "95%" /* sm: isMobile ? "100%" : "95%" */ },
								lineHeight: 1.2
							}}
							onClick={onClick}
						>
							Continue Shopping
						</CTA>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="loyalty_points_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "95%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
